import React from 'react';
import cs from 'classnames';
import Popover from 'react-popover';
import styles from './Dropdown.css';
import { Box } from 'src/lib/StyledComponents';

class Dropdown extends React.Component {
	constructor() {
		super();
		this.state = { popupVisible: false };
	}
	toggle() {
		if (this.props.onChange) return this.props.onChange(!this.state.opened);
		this.setState({
			popupVisible: !this.state.popupVisible,
		});
	}
	handleClickOutside() {
		if (this.props.onChange) return this.props.onChange(false);
		this.setState({
			popupVisible: false,
		});
	}

	render() {
		const { children, opened, style, noPadding, button, placement, closeOnClick } = this.props;
		const popoverProps = {
			isOpen: opened || this.state.popupVisible,
			preferPlace: this.state.preferPlace,
			place: placement || 'below',
			enterExitTransitionDurationMs: 200,
			onOuterAction: this.handleClickOutside.bind(this),
			body: [
				<Box
					onClick={closeOnClick && this.handleClickOutside.bind(this)}
					className={cs(styles.DropdownContent, {
						[styles.noPadding]: noPadding,
					})}
					key={'popover'}
				>
					{children}
				</Box>,
			],
		};

		return (
			<Popover className={styles.Dropdown} {...popoverProps}>
				<Box
					{...style}
					className={styles.DropdownToggleButton}
					onClick={this.toggle.bind(this)}
				>
					{button || <strong>⋮</strong>}
				</Box>
			</Popover>
		);
	}
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js